import React, { useContext, useRef } from "react";
import {
  Heading,
  Grid,
  Column,
  Section,
  UnorderedList,
  ListItem,
  ClickableTile,
} from "@carbon/react";
import { NotificationContext } from "../../layout/Layout";
import { AlertDialog } from "../../common/CustomNotification";
import { FormattedMessage, injectIntl, useIntl } from "react-intl";
import PageBreadCrumb from "../../common/PageBreadCrumb";

let breadcrumbs = [
  { label: "home.label", link: "/" },
  { label: "breadcrums.admin.managment", link: "/MasterListsPage" },
  {
    label: "master.lists.page.test.management",
    link: "/MasterListsPage/testManagementConfigMenu",
  },
];

function TestManagementConfigMenu() {
  const { notificationVisible, setNotificationVisible, addNotification } =
    useContext(NotificationContext);

  const intl = useIntl();

  const componentMounted = useRef(false);

  return (
    <>
      {notificationVisible === true ? <AlertDialog /> : ""}
      <div className="adminPageContent">
        <PageBreadCrumb breadcrumbs={breadcrumbs} />
        <Grid fullWidth={true}>
          <Column lg={16} md={8} sm={4}>
            <Section>
              <Heading>
                <FormattedMessage id="master.lists.page.test.management" />
              </Heading>
            </Section>
          </Column>
        </Grid>
        <br />
        <div className="orderLegendBody">
          <Grid fullWidth={true}>
            <Column lg={16} md={8} sm={4}>
              <Section>
                <Section>
                  <Section>
                    <Heading>
                      <FormattedMessage id="configuration.test.management.spelling" />
                    </Heading>
                  </Section>
                </Section>
              </Section>
            </Column>
          </Grid>
          <br />
          <hr />
          <br />
          <Grid fullWidth={true}>
            <Column lg={16} md={8} sm={4}>
              <UnorderedList>
                <ClickableTile
                  href="/MasterListsPage/TestRenameEntry"
                  id="TestRenameEntry"
                >
                  <FormattedMessage id="configuration.test.rename" />
                  <UnorderedList nested>
                    <ListItem>
                      <FormattedMessage id="configuration.test.rename.explain" />
                    </ListItem>
                  </UnorderedList>
                </ClickableTile>
                <br />
                <ClickableTile
                  href="/MasterListsPage/PanelRenameEntry"
                  id="PanelRenameEntry"
                >
                  <FormattedMessage id="configuration.panel.rename" />
                  <UnorderedList nested>
                    <ListItem>
                      <FormattedMessage id="configuration.panel.rename.explain" />
                    </ListItem>
                  </UnorderedList>
                </ClickableTile>
                <br />
                <ClickableTile
                  href="/MasterListsPage/SampleTypeRenameEntry"
                  id="SampleTypeRenameEntry"
                >
                  <FormattedMessage id="configuration.type.rename" />
                  <UnorderedList nested>
                    <ListItem>
                      <FormattedMessage id="configuration.type.rename.explain" />
                    </ListItem>
                  </UnorderedList>
                </ClickableTile>
                <br />
                <ClickableTile
                  href="/MasterListsPage/TestSectionRenameEntry"
                  id="TestSectionRenameEntry"
                >
                  <FormattedMessage id="configuration.testSection.rename" />
                  <UnorderedList nested>
                    <ListItem>
                      <FormattedMessage id="configuration.testSection.rename.explain" />
                    </ListItem>
                  </UnorderedList>
                </ClickableTile>
                <br />
                <ClickableTile
                  href="/MasterListsPage/UomRenameEntry"
                  id="UomRenameEntry"
                >
                  <FormattedMessage id="configuration.uom.rename" />
                  <UnorderedList nested>
                    <ListItem>
                      <FormattedMessage id="configuration.uom.rename.explain" />
                    </ListItem>
                  </UnorderedList>
                </ClickableTile>
                <br />
                <ClickableTile
                  href="/MasterListsPage/SelectListRenameEntry"
                  id="SelectListRenameEntry"
                >
                  <FormattedMessage id="configuration.selectList.rename" />
                  <UnorderedList nested>
                    <ListItem>
                      <FormattedMessage id="configuration.selectList.rename.explain" />
                    </ListItem>
                  </UnorderedList>
                </ClickableTile>
                <br />
                <ClickableTile
                  href="/MasterListsPage/MethodRenameEntry"
                  id="MethodRenameEntry"
                >
                  <FormattedMessage id="configuration.method.rename" />
                  <UnorderedList nested>
                    <ListItem>
                      <FormattedMessage id="configuration.method.rename.explain" />
                    </ListItem>
                  </UnorderedList>
                </ClickableTile>
              </UnorderedList>
            </Column>
          </Grid>
          <br />
          <hr />
          <br />
          <Grid fullWidth={true}>
            <Column lg={16} md={8} sm={4}>
              <Section>
                <Section>
                  <Section>
                    <Heading>
                      <FormattedMessage id="configuration.test.management.organization" />
                    </Heading>
                  </Section>
                </Section>
              </Section>
            </Column>
          </Grid>
          <br />
          <hr />
          <br />
          <Grid fullWidth={true}>
            <Column lg={16} md={8} sm={4}>
              <UnorderedList>
                <ClickableTile
                  href="/MasterListsPage/TestCatalog"
                  id="TestCatalog"
                >
                  <FormattedMessage id="configuration.test.catalog" />
                  <UnorderedList nested>
                    <ListItem>
                      <FormattedMessage id="configuration.test.catalog.explain" />
                    </ListItem>
                  </UnorderedList>
                </ClickableTile>
                <br />
                <ClickableTile
                  href="/MasterListsPage/MethodManagement"
                  id="MethodManagement"
                >
                  <FormattedMessage id="configuration.method" />
                  <UnorderedList nested>
                    <ListItem>
                      <FormattedMessage id="configuration.method.explain" />
                    </ListItem>
                  </UnorderedList>
                </ClickableTile>
                <br />
                <ClickableTile href="/MasterListsPage/TestAdd" id="TestAdd">
                  <FormattedMessage id="configuration.test.add" />
                  <UnorderedList nested>
                    <ListItem>
                      <FormattedMessage id="configuration.test.add.explain" />
                    </ListItem>
                  </UnorderedList>
                </ClickableTile>
                <br />
                <ClickableTile
                  href="/MasterListsPage/TestModifyEntry"
                  id="TestModifyEntry"
                >
                  <FormattedMessage id="configuration.test.modify" />
                  <UnorderedList nested>
                    <ListItem>
                      <FormattedMessage id="configuration.test.modify.explain" />
                    </ListItem>
                  </UnorderedList>
                </ClickableTile>
                <br />
                <ClickableTile
                  href="/MasterListsPage/TestActivation"
                  id="TestActivation"
                >
                  <FormattedMessage id="configuration.test.activate" />
                  <UnorderedList nested>
                    <ListItem>
                      <FormattedMessage id="configuration.test.activate.explain" />
                    </ListItem>
                  </UnorderedList>
                </ClickableTile>
                <br />
                <ClickableTile
                  href="/MasterListsPage/TestOrderability"
                  id="TestOrderability"
                >
                  <FormattedMessage id="configuration.test.orderable" />
                  <UnorderedList nested>
                    <ListItem>
                      <FormattedMessage id="configuration.test.orderable.explain" />
                    </ListItem>
                  </UnorderedList>
                </ClickableTile>
                <br />
                <ClickableTile
                  href="/MasterListsPage/TestSectionManagement"
                  id="TestSectionManagement"
                >
                  <FormattedMessage id="configuration.testUnit.manage" />
                  <UnorderedList nested>
                    <ListItem>
                      <FormattedMessage id="configuration.testUnit.manage.explain" />
                    </ListItem>
                  </UnorderedList>
                </ClickableTile>
                <br />
                <ClickableTile
                  href="/MasterListsPage/SampleTypeManagement"
                  id="SampleTypeManagement"
                >
                  <FormattedMessage id="configuration.sampleType.manage" />
                  <UnorderedList nested>
                    <ListItem>
                      <FormattedMessage id="configuration.sampleType.manage.explain" />
                    </ListItem>
                  </UnorderedList>
                </ClickableTile>
                <br />
                <ClickableTile
                  href="/MasterListsPage/UomManagement"
                  id="UomManagement"
                >
                  <FormattedMessage id="configuration.uom.manage" />
                  <UnorderedList nested>
                    <ListItem>
                      <FormattedMessage id="configuration.uom.manage.explain" />
                    </ListItem>
                  </UnorderedList>
                </ClickableTile>
                <br />
                <ClickableTile
                  href="/MasterListsPage/PanelManagement"
                  id="PanelManagement"
                >
                  <FormattedMessage id="configuration.panel.manage" />
                  <UnorderedList nested>
                    <ListItem>
                      <FormattedMessage id="configuration.panel.manage.explain" />
                    </ListItem>
                  </UnorderedList>
                </ClickableTile>
                <br />
                <ClickableTile
                  href="/MasterListsPage/ResultSelectListAdd"
                  id="ResultSelectListAdd"
                >
                  <FormattedMessage id="configuration.selectList.add" />
                  <UnorderedList nested>
                    <ListItem>
                      <FormattedMessage id="configuration.selectList.add.explain" />
                    </ListItem>
                    <ListItem>
                      <FormattedMessage id="configuration.selectList.add.alert" />
                    </ListItem>
                  </UnorderedList>
                </ClickableTile>
                <br />
                <ClickableTile href="/MasterListsPage/reflex" id="reflex">
                  <FormattedMessage id="sidenav.label.admin.testmgt.reflex" />
                </ClickableTile>
                <br />
                <ClickableTile
                  href="/MasterListsPage/calculatedValue"
                  id="calculatedValue"
                >
                  <FormattedMessage id="sidenav.label.admin.testmgt.calculated" />
                </ClickableTile>
              </UnorderedList>
            </Column>
          </Grid>
          <br />
          <hr />
          <br />
        </div>
      </div>
    </>
  );
}

export default injectIntl(TestManagementConfigMenu);
